export const remapCurrency: {[x: string]: string} = {
    EUR: '€',
    GBP: '£',
    USD: '$',
    BRL: 'R$',
    default: '$' // Default currency symbol
}
